module.exports = __webpack_public_path__ + "static/img/img15.dc4d26d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic/img15.png
// module id = HxaB
// module chunks = 0